module.exports = __webpack_public_path__ + "static/media/tv.244ba6c0.svg";